import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  HostBinding,
  Renderer2,
} from '@angular/core';
import { StretchedLinkDirective } from '../stretched-link/stretched-link.directive';
import { CardMainDirective } from './card-main.directive';
import { MatRipple } from '@angular/material/core';

@Component({
    selector: 'lui-card',
    templateUrl: './card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CardComponent implements AfterContentInit {
  @HostBinding('class') className = 'lui-card';
  @HostBinding('class.lui-card-is-link') linkClass = false;
  // @HostBinding('matRipple') rippleDirective = true;
  // @HostBinding('matRippleTrigger') get matRippleTrigger() {
  //   return this.stretchedLinkEl;
  // }

  @ContentChild(CardMainDirective) _content!: CardMainDirective;

  @ContentChild(StretchedLinkDirective, { descendants: true })
  stretchedLink: StretchedLinkDirective | undefined;

  @ContentChild(StretchedLinkDirective, { descendants: true, read: ElementRef })
  stretchedLinkEl: ElementRef | undefined;

  ngAfterContentInit(): void {
    if (this.stretchedLink) {
      this.linkClass = true;
    }
  }
}
